export default __webpack_public_path__ + "static/floor1-slide-5-5a3744e88ed24af13dee93536fb898bb.jpg";